export default __webpack_public_path__ + "static/media/img--design-9.481d8db8.jpg";